import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppointmentService } from '../../../shared/services/appointment.service';
import { Appointment } from '../../../shared/models/appointment.model';

import swal from 'sweetalert2';
import { DateUtility } from '../../../shared/utilities/date.utility';

declare var jQuery: any;

@Component({
  selector: 'app-consult-medical-appointment',
  templateUrl: './consult-medical-appointment.component.html',
  styleUrls: ['./consult-medical-appointment.component.css']
})
export class ConsultMedicalAppointmentComponent implements OnInit {

  citasMedicas: Appointment[];
  nombreBeneficiario: string;
  documentoBeneficiario: string;
  collapseInDatosContrato = false;
  collapseInBeneficiario = false;
  showSpinnerCitasMedicas = false;

  interval : any;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _appointmentService: AppointmentService
  ) { }

  ngOnInit() {
    this.nombreBeneficiario = sessionStorage.getItem('nombreBeneficiario');
    this.documentoBeneficiario = sessionStorage.getItem('documentoBeneficiario');

    this.getMedicalAppointments();

    this.interval = setInterval(() => {
      this.calcularCaducidadPagoConsulta();
    }, 5000);
  }

  private getMedicalAppointments(){

    this.citasMedicas = undefined;
    this.showSpinnerCitasMedicas = true;
    this._appointmentService.getMedicalAppointmentsPanacea(this.documentoBeneficiario).subscribe(
      res => {
        //console.log(res);
        this.showSpinnerCitasMedicas = false;          
        this.citasMedicas = res;
        this.calcularCaducidadPagoConsulta();
      },
      err => {
        this.showSpinnerCitasMedicas = false;
        console.log(err);
      }
    );

  }

  irHomeCitasMedicas() {
    this._router.navigate(['/office/medical_appointment/home']);
  }

  clickPanelHeadindDatosContrato() {
    this.collapseInDatosContrato = !this.collapseInDatosContrato;
  }

  clickPanelHeadindBeneficiario() {
    this.collapseInBeneficiario = !this.collapseInBeneficiario;
  }

  cancelarCita(cita: Appointment) {

    this._appointmentService.getValidaFechaCancelacion(cita.fecha).subscribe(
      res => {
        //console.log(res);

        if (res) {                
         
          let _fechaHora = cita.fechaFormat + ' ' + cita.horaFormat;

          let _html = '';
          _html += `
          <p style="font-size: 15px; text-align: left; font-weight: bold">Cancelación cita médica:</p>
          <table id="tableResumenCitaMedica" class="table table-bordered">
            <tr>
              <td style="background-color: #1d7bbb; color: #ffff">Centro Médico</td>
              <td>${cita.centro}</td>
            </tr>
            <tr>
              <td style="background-color: #1d7bbb; color: #ffff">Medico</td>
              <td>${cita.name}</td>
            </tr>
            <tr>
            <td style="background-color: #1d7bbb; color: #ffff">Especialidad</td>
            <td>${cita.especialidad}</td>
            </tr>
            <tr>
            <td style="background-color: #1d7bbb; color: #ffff">Fecha Cita</td>
              <td>${_fechaHora}</td>
            </tr>  
           
          </table>   
          <br/>
          <p style="font-size: 15px; text-align: left; font-weight: bold">Motivo de cancelación:</p>
          `;

          var _array = [
            { id: 1, name: 'Motivo personal' },
            { id: 2, name: 'Ya asistió; con otro médico' },
            { id: 3, name: 'Aplaza cita' },
            { id: 4, name: 'Adelanta Cita' },
            { id: 5, name: 'Asistió por urgencias / Clínica' },
            { id: 6, name: 'Asistió por cita no programada' },
            { id: 7, name: 'Otros' }
          ];

          var options = {};
          $.map(_array,
            function (o) {
              options[o.id] = o.name;
            });

          swal({
            width: 600,
            padding: 30,
            showCloseButton: true,
            type: 'question',
            html: _html,
            animation: true,
            allowOutsideClick: false,
            input: 'select',
            inputOptions: options,
            inputPlaceholder: 'Seleccione un motivo de cancelación...',
            confirmButtonClass: 'btn btn-warning btn-confirm-modal',
            confirmButtonText: 'Cancelar Cita',
            showCancelButton: true,
            cancelButtonClass: 'btn btn-info',
            cancelButtonText: 'Cerrar',
            buttonsStyling: false,
            focusConfirm: false,
            onOpen: () => {
              jQuery("#tableResumenCitaMedica").addClass("tableConfirmaCitaMedica");
              jQuery(".swal2-select").css('text-align', 'center');
              jQuery(".swal2-select").css('font-size', '15px');
              jQuery(".swal2-select").select2();
            },
            inputValidator: (value) => {
              return new Promise((resolve) => {
                if (value !== '') {

                  let _obs = jQuery(".swal2-select").val();

                  let _obj = {
                    nota: cita.nota,
                    centro: cita.codeCentro,
                    observacion: _obs
                  }

                  this._appointmentService.putCancelaCitaMedicaPanacea(_obj).subscribe(
                    res => {
                      if (res.message === 'CANCELADO') {
                        swal.close();
                        this.getMedicalAppointments();
                        swal({
                          title: 'La cita ha sido cancelada',
                          html: '<span style="font-size: 15px">Gracias por utilizar nuestro servicio.</span>',
                          type: 'success',
                          confirmButtonClass: 'btn btn-primary',
                          buttonsStyling: false,
                          focusConfirm: false
                        });
                        
                      } else {
                        swal.close();
                        swal({
                          title: 'La cita no fue cancelada',
                          html: '<span style="font-size: 15px">Gracias por utilizar nuestro servicio.</span>',
                          type: 'warning',
                          confirmButtonClass: 'btn btn-primary',
                          buttonsStyling: false,
                          focusConfirm: false
                        });

                      }
                    },
                    err => {                      
                      resolve('<span style="font-size: 15px">' + err.error.message + '</span>')
                    }
                  )
                } else {
                  resolve('<span style="font-size: 15px">Debe seleccionar un motivo de cancelación</span>');

                }
              })
            }
          });

        } else {
          swal({
            title: 'Lo sentimos:',
            html: '<br/><p style="font-size: 15px;">El tiempo límite de cancelación por este canal es de <b>24 horas</b><br/><br/>Gracias por utilizar nuestro servicio.</p>',
            type: 'warning',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });
        }
      },
      err => {
        console.log(err);
      }
    )

  }

  calcularCaducidadPagoConsulta() {
    
    for(let i of this.citasMedicas) {
      let fechaCita = new Date(i.fecha);
      let fechaActual = new Date();

      // Se suman 30 minutos a la hora actual
      fechaActual = new Date(fechaActual.setMinutes(fechaActual.getMinutes() + 30));

      if(fechaActual >= fechaCita ) {
        i.pagoConsultaVencida = true;
      }
      else {
        i.pagoConsultaVencida = false;
      }
    }
  }

  pagoConsulta(cita: Appointment) {
    if(!cita.pago) {
      this._router.navigate(['/office/medical_appointment/payment'], 
      { queryParams: 
        { 
          nota: cita.nota, 
          especialidad: cita.especialidad, 
          centro: cita.centro, 
          especialista: cita.name, 
          pagoConsultaVencida: cita.pagoConsultaVencida 
        } 
      });
    }
    else {
      swal({
        title: 'No se puede proceder con el pago',
        html: '<p style="font-size:14px"> La cita ya tiene pago </p>',
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      })
    } 
  }

}



// WEBPACK FOOTER //
// /app/src/app/office/medical-appointment/consult-medical-appointment/consult-medical-appointment.component.ts